<template>
    <div class="changelog">
        <Header :app="app" title="Changelog" :left="true">
            <template v-slot:left>
                <a href="javascript:;" v-on:click="app.$router.go(-1)">
                    &laquo;
                </a>
            </template>
        </Header>

        <div class="content">
            <ul>
                <li v-for="(details, version) in changelog" :key="version">
                    <p class="version">
                        <strong>{{version}}</strong>
                    </p>
                    <p class="details">
                        {{details}}
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import changelog from '../../changelog.json';
import Header    from '@/components/header/component.vue';

export default {
    name: 'analytics',
    props: ['app'],
    components: {
        Header
    },
    data() {
        return {
            changelog: changelog
        };
    }
};
</script>
